import {configureStore} from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import prouctReducer from "./slices/productsSlice";
import cartReducer from "./slices/cartSlice";
import checkoutReducer from "./slices/checkoutSlice";
import orderReducer from "./slices/orderSlice";
import adminReducer from "./slices/adminSlice";
import adminProductReducer from "./slices/adminProductSlice";
import adminOrdersReducer from "./slices/adminOrderSlice";
import adminReturnReducer from "./slices/adminReturnSlice";


import vendorReducer from "./slices/vendorSlice";
import vendorProductReducer from "./slices/vendorProductSlice";
import vendorOrderReducer from "./slices/vendorOrderSlice";
import vendorPayoutReducer from "./slices/vendorPayoutSlice";



const store = configureStore({
    reducer: {
        auth: authReducer,
        products: prouctReducer,
        cart: cartReducer,
        checkout: checkoutReducer,
        orders: orderReducer,
        admin: adminReducer,
        adminProducts: adminProductReducer,
        adminOrders: adminOrdersReducer,
        adminReturns: adminReturnReducer,


        vendor: vendorReducer,
    vendorProducts: vendorProductReducer,
    vendorOrders: vendorOrderReducer,
    vendorPayouts: vendorPayoutReducer,
    },

});

export default store;
